import { render, staticRenderFns } from "./GeneralTile.vue?vue&type=template&id=7bfbd42a"
import script from "./GeneralTile.vue?vue&type=script&lang=js"
export * from "./GeneralTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports